export const productRequest = {
  productRequest: "Product Request",
  myRequests: "My Requests",
  createRequest: "Create Request",
  request: "Request",
  requestDetails: "Request Details",
  requestProperties: "Request Properties",
  requestCategories: "Request Categories",
  createProductRequest: "Create Product Request",
  deleteProductRequest: "Delete Product Request",
  areYouSureYouWantToDeleteThisProductRequest:
    "Are you sure you want to delete this Product Request?",
  thisActionCannotBeUndone: "This action cannot be undone",
  productRequestDeletedSuccessfully: "Product Request deleted successfully",
  aiDsDtRequestUpdatedSuccessfully: "AI-DS/DT Request updated successfully",
  operationRequestUpdatedSuccessfully: "Operation Request updated successfully",
  operationRequestSavedSuccessfully: "Operation Request saved successfully",
  completed: "Completed",
  rejected: "Rejected",
  inProgress: "In Progress",
  requested: "Requested",
  pending: "Pending",
  working: "Working",
  currentStep: "Current Step",
  productRequestStatus: "Product Request Status",
  factoryOwnerRequirements: "Factory Owner Requirements",
  capabilities: "Capabilities",
  addOperation: "Add Operation",
  removeLastOperation: "Remove Last Operation",
  addStep: "Add Step",
  removeLastStep: "Remove Last Step",
  unmetTaktPenalty: "Unmet Takt Penalty",
  operationName: "Operation Name",
  capability: "Capability",
  serviceNotAvailable: "Service not available",
  results: "Results",
  plantLocation: "Plant Location",
  qualityProduction: "Quality Production",
  scrapRate: "Scrap Rate (%)",
  spaceAvailabilityIndex: "Space Availability Index",
  throughputRate: "Throughput Rate",
  downtimeCost: "Downtime Cost",
  energyConsumption: "Energy Consumption",
  phaseType: "Phase Type",
  cost: "Cost (€)",
  procurement: "Procurement",
  production: "Production",
  requiredProperties: "Required Properties",
  include: "Include",
  incumbentEquipment: "Incumbent Equipment",
  viewProduct: "View Product",
  totalTimeOfRepairs: "Total Time of Repairs",
  numberOfRepairs: "Number of Repairs",
  availableOperatingTimePerPart: "Available Operating Time per Part",
  plannedProductionTimePerPart: "Planned Production Time per Part",
  plannedCycleTime: "Planned Cycle Time",
  productionLeadTime: "Production Lead Time",
  cycleTime: "Cycle Time",
  oee: "OEE (Overall Equipment Efficiency)",
  cpk: "CPK (Process Capability Index)",
  ppk: "PPK (Process Performance Index)",
  mttr: "MTTR (Mean Time To Repair) (hours)",
  mtbf: "MTBF (Mean Time Between Failures)",
  ppm: "PPM (Parts Per Million)",
  dpmo: "DPMO (Defects Per Million Opportunities)",
  fpy: "FPY (First Pass Yield)",
  rty: "RTY (Rolled Throughput Yield)",
  productionPhaseSupportRequest: "Production Phase Support Request",
  maximumMTTR: "Maximum MTTR",
  minimumMTBF: "Minimum MTBF",
  budget: "Budget",
  operations: "Operations",
  processDuration: "Process Duration",

  numberOfSteps: "Number of Steps",
  precedentOperations: "Precedent Operations",
  steps: "Steps",
  stepName: "Step Name",
  stepDuration: "Step Duration",
  stepsNo: "Steps No",
  step: "Step",
  operation: "Operation",
  noIncumbentEquipment: "No Incumbent Equipment",
  group: "Group",
  groups: "Groups",
  addGroup: "Add Group",
  existingLine: "Existing Line",
  minValue: "Min Value",
  maxValue: "Max Value",
  estimatedIndirectTrainingCost: "Estimated Indirect Training Cost",
  partToBeProduced: "Part to be Produced",
  partToBeProducedPerYear: "Part to be Produced per Year",
  productionHoursPerYear: "Production Hours per Year",
  productionDaysPerYear: "Production (Days / Year)",
  productionHoursPerDay: "Production (Hours / Day)",
  possibleShopFloorExtensions: "Possible Shop Floor Extensions",
  preferredManufacturer: "Preferred Manufacturer",
  maximumNumberStations: "Maximum Number of Stations",
  onlySecondHand: "Only Second Hand",
  onlyNew: "Only New-built",
  maxCycleLoss: "Maximum Cycle Loss (sec)",
  maxEquipmentPowerConsumption: "Maximum Equipment Power Consumption (kW)",
  minRUL: "Minimum Remaining Useful Life (years)",
  willingToUpSkill: "Willing to Up-Skill",
  kpiSelectionRequest: "KPI Selection Request",
  addResourceGroup: "Add Resource Group",
  resourceGroup: "Resource Group",
  removeResourceGroup: "Remove Resource Group",
  addStation: "Add Station",
  removeStation: "Remove Station",
  machine: "Machine",
  machines: "Machines",
  noAvailableMachines: "No Available Machines",
  addMachine: "Add Machine",
  removeMachine: "Remove Machine",
  removeStep: "Remove Step",
  operationDuration: "Operation Duration",
  station: "Station",
  stations: "Stations",
  processingRequest: "Request Submitted Successfully",
  longRunningProcessDisclaimer:
    "Your request has been submitted successfully. This is a long-running process that may take some time to complete. The results will appear on this page once ready. You will be notified once the process is complete.",
  backToRequests: "Back to My Requests",
  confirmChangeSelection:
    "Are you sure you want to change the selection? Any unsaved progress will be lost.",
};
